
import process from 'process/browser.js';
import { Buffer } from 'buffer';
import 'setimmediate'; // Production-ready polyfill for setImmediate


if (typeof window !== 'undefined') {
  
  window.process = window.process || process;
  window.global = window.global || window;
  window.Buffer = window.Buffer || Buffer;
  
  // Add missing stdout/stderr with isTTY for browser compatibility
  if (window.process && !window.process.stdout) {
    window.process.stdout = { isTTY: false };
  }
  if (window.process && !window.process.stderr) {
    window.process.stderr = { isTTY: false };
  }
 
  if (window.process && typeof window.process.env !== 'object') {
    window.process.env = {};
  }
}


export { process, Buffer };
